import { UncontrolledTooltip } from "reactstrap";
import { ExposedSidesLayout } from "../canvas";

function ModuleReviewSummary({ item }) {
  const selectedValues = item.customizations.selected_values || {};
  const exposedSides = item.customizations.exposed_sides;
  const internalColorIdentifier = item.project_settings.internal_color
    ? item.project_settings.internal_color.identifier
    : null;

  const internalColorProperty = item.property_list.find(
    (property) => property.identifier === "internal_color"
  );

  const internalColorProjectSetting =
    internalColorProperty && internalColorIdentifier
      ? internalColorProperty.options.find(
          (option) => option.identifier === internalColorIdentifier
        )
      : null;

  const shutterColorIdentifier = item.project_settings.shutter_color
    ? item.project_settings.shutter_color.identifier
    : null;

  const shutterColorProperty = item.property_list.find(
    (property) => property.identifier === "shutter_color"
  );

  const shutterColorProjectSetting =
    shutterColorProperty && shutterColorIdentifier
      ? shutterColorProperty.options.find(
          (option) => option.identifier === shutterColorIdentifier
        )
      : null;

  const shutterMaterialIdentifier = item.project_settings.shutter_material
    ? item.project_settings.shutter_material.identifier
    : null;

  const shutterMaterialProperty = item.property_list.find(
    (property) => property.identifier === "shutter_material"
  );

  const shutterMaterialProjectSetting =
    shutterMaterialProperty && shutterMaterialIdentifier
      ? shutterMaterialProperty.options.find(
          (option) => option.identifier === shutterMaterialIdentifier
        )
      : null;

  const carcassMaterialIdentifier = item.project_settings.carcass_material
    ? item.project_settings.carcass_material.identifier
    : null;

  const carcassMaterialProperty = item.property_list.find(
    (property) => property.identifier === "carcass_material"
  );

  const carcassMaterialProjectSetting =
    carcassMaterialProperty && carcassMaterialIdentifier
      ? carcassMaterialProperty.options.find(
          (option) => option.identifier === carcassMaterialIdentifier
        )
      : null;

  const hasExpoSides =
    exposedSides && exposedSides.filter((side) => side !== null).length > 0;

  return (
    <div
      className="position-fixed d-flex flex-column"
      style={{
        left: "250px",
        right: "300px",
        bottom: 0,
        fontSize: "12px",
      }}
    >
      <div
        className="p-2 d-flex justify-content-start align-items-center"
        style={{ color: "#999999" }}
      >
        <i className="fa-solid fa-gear ms-1" style={{ color: "#999999" }} />
        <div className="ps-2">Indicates project setting</div>
      </div>

      <div
        className="d-flex px-2 text-nowrap"
        style={{
          backgroundColor: "#EEE",
          borderTop: "1px solid #DDD",
          boxShadow: "0 0 5px #AAA",
        }}
      >
        {[
          {
            label: "Inner Lam",
            value:
              selectedValues.internal_color?.short_name ||
              internalColorProjectSetting?.short_name ||
              "None",
            isDefault: !selectedValues.internal_color,
            icon: !selectedValues.internal_color,
          },
          {
            label: "Outer Lam",
            value:
              selectedValues.shutter_color?.short_name ||
              shutterColorProjectSetting?.short_name ||
              "None",
            isDefault: !selectedValues.shutter_color,
            icon: !selectedValues.shutter_color,
          },
          {
            label: "Expo Lam",
            value: hasExpoSides ? (
              <div style={{ display: "flex", alignItems: "center" }}>
                <ExposedSidesLayout exposedSides={exposedSides} />
                <span style={{ marginLeft: "5px" }}>
                  {selectedValues.shutter_color
                    ? selectedValues.shutter_color.short_name || "None"
                    : shutterColorProjectSetting.short_name || "None"}
                </span>
              </div>
            ) : (
              <span style={{ color: "#999999" }}>None</span>
            ),
            isDefault: !hasExpoSides,
            icon: false,
          },
          {
            label: "Carcass",
            value:
              selectedValues.carcass_material?.short_name ||
              carcassMaterialProjectSetting?.short_name ||
              "None",
            isDefault: !selectedValues.carcass_material,
            icon: !selectedValues.carcass_material,
          },
          {
            label: "Shutter",
            value:
              selectedValues.shutter_material?.short_name ||
              shutterMaterialProjectSetting?.short_name ||
              "None",
            isDefault: !selectedValues.shutter_material,
            icon: !selectedValues.shutter_material,
          },
          {
            label: "Remarks",
            value: item.remarks || "None",
            icon: false,
            isDefault: !item.remarks,
            is_remarks: true,
          },
        ].map((item, index) => (
          <div
            key={index}
            className="d-flex flex-column text-left"
            style={{ padding: "8px" }}
          >
            <div className="mb-1" style={{ color: "#999999" }}>
              {item.label}
            </div>
            <div style={{ display: "flex", alignItems: "center" }}>
              {item.is_remarks && (
                <UncontrolledTooltip target="remarks" placement="top">
                  {item.value}
                </UncontrolledTooltip>
              )}
              <div
                className={`text-left ${item.isDefault && "text-secondary"}`}
                style={{
                  fontWeight: item.isDefault ? "normal" : "bold",
                }}
                id={item.is_remarks && "remarks"}
              >
                {item.value}
              </div>
              {item.icon && (
                <i
                  className="fa-solid fa-gear ms-1"
                  style={{ color: "#999999" }}
                />
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default ModuleReviewSummary;
